import { disablePageScroll, enablePageScroll } from 'scroll-lock'

const bioWindow = document.querySelector('.bio__modal')
const bioOpen = document.querySelectorAll('[data-bio-open]')
const bioClose = document.querySelectorAll('[data-bio-close]')

// document.querySelectorAll('.bio__detail').forEach((el) => {
//     if (el.clientHeight < el.scrollHeight) {
//         console.log('Found the worst element ever: ', el)
//     } else {
//         console.log('Found a good element: ', el)
//     }
// })

document.onkeydown = function(e) {
    if (e.key === 'Escape') {
        enablePageScroll(bioWindow)
    }
}

bioOpen.forEach(el => {
    el.addEventListener('click', (event) => {
        disablePageScroll(bioWindow)
    })
})

bioClose.forEach(el => {
    el.addEventListener('click', (event) => {
        enablePageScroll(bioWindow)
    })
})
